import { render, staticRenderFns } from "./HealthInformation.vue?vue&type=template&id=ef9cce7a&scoped=true"
import script from "./HealthInformation.vue?vue&type=script&lang=ts"
export * from "./HealthInformation.vue?vue&type=script&lang=ts"
import style0 from "./HealthInformation.vue?vue&type=style&index=0&id=ef9cce7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9cce7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef9cce7a')) {
      api.createRecord('ef9cce7a', component.options)
    } else {
      api.reload('ef9cce7a', component.options)
    }
    module.hot.accept("./HealthInformation.vue?vue&type=template&id=ef9cce7a&scoped=true", function () {
      api.rerender('ef9cce7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientRightSide/HealthInformation.vue"
export default component.exports